module.exports = __webpack_public_path__ + "media/images/story/typo/aboutCute-dd1f1f8d6c3e71e74c1d006e3a9aae8e.svg";